export default "__VITE_ASSET__ab7df19a__"